import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { interfaceLanguageOptions } from "@/common/constants";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const LanguageSelect = (props: Props): JSX.Element => {
  return (
    <div className="bg-gray-100 rounded-md px-3">
      <Select value={props.value} onValueChange={props.onChange}>
        <SelectTrigger className="border-none bg-transparent shadow-none focus:ring-0 px-0 w-auto">
          <SelectValue>
            <span className="text-xl">
              {
                interfaceLanguageOptions.find((l) => l.value === props.value)
                  ?.flag
              }
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {interfaceLanguageOptions.map((lang) => (
            <SelectItem key={lang.value} value={lang.value}>
              <span className="mr-2">{lang.flag}</span>
              <span>{lang.label}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
